import type { AddedConcept, AgentConcept, RequiredAttribute } from '../state/createProjectSlice';

// TODO: cleanup with cp_annotation_createproject_agent ff

export interface OrderedAgentConcept {
  conceptGroupId: string;
  concept: AgentConcept;
  requiredAttributes: RequiredAttribute[];
}

/**
 * The builder's saved concepts, one per step 2 concept group, in step 2 order. A step 2 card
 * whose group is not chosen yet, or that has nothing saved in the builder, is left out.
 */
export const getAgentConceptsInStep2Order = (
  addedConcepts: AddedConcept[],
  concepts: Record<string, AgentConcept>
): OrderedAgentConcept[] => {
  const seenGroupIds = new Set<string>();
  const ordered: OrderedAgentConcept[] = [];
  addedConcepts.forEach(({ conceptGroupId, requiredAttributes }) => {
    if (!conceptGroupId || seenGroupIds.has(conceptGroupId)) return;
    const concept = concepts[conceptGroupId];
    if (!concept) return;
    seenGroupIds.add(conceptGroupId);
    ordered.push({ conceptGroupId, concept, requiredAttributes });
  });
  return ordered;
};
